<template>
  <div
    v-if="bill === 0"
    class="box danger m-b-0"
    style="background-color: #FF6F61">
    <div class="box-body">
      <i class="fa fa-exclamation-triangle m-r-sm"/>
      Kindly update your latest information in the <a href="/franchise/billing"> <b> Billing Page </b> </a> section to ensure it is up-to-date.
    </div>
  </div>
</template>

<style>
.box-aest {
    padding-bottom: -10%;
}

.renewal-header-old {
    position: fixed;
    top: 3.5rem;
    left: 0;
    right: 0;
    margin: inherit;
    z-index: 1020;
}

.renewal-header ~ .app-body {
    padding-top: 7rem;
}
</style>

<script>
import Auth from '@js/plugins/auth';
export default {
    data() {
        return {
            user: null,
            bill: 1,
        };
    },
    created() {
        this.information();
        this.user = Auth.user();
    },
    methods: {
        information() {
            axios
                .get(Laroute.route('franchise.vue.checkbillinformation'))
                .then(({ data }) => {
                    this.bill = data.bill;
                })
                .catch(err => console.error(err));
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/subscription-renewal/bill-announcement.vue